import { TranslocoService } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { icoExpiredDuo, TranslocoErrorSpecification } from '@platform-frontend/ui-tools';
import { CloseWindow } from '@platform-frontend/util';
import { CHECKOUT_TRANSLOCO_SCOPE } from './checkout-transloco-scope';

const ERR_METADATA_ALREADY_USED_FOR_EXPIRED_ASSET = (translocoService: TranslocoService, store: Store): TranslocoErrorSpecification => ({
  type: 'transloco',
  buttonClick: () => store.dispatch(new CloseWindow()),
  buttonName: null,
  descriptions: [
    {
      key: 'checkout.errorSpecification.metadataAlreadyUsedForExpiredAsset.description',
      scope: CHECKOUT_TRANSLOCO_SCOPE
    }
  ],
  icon: icoExpiredDuo,
  title: translocoService.selectTranslate('errorSpecification.metadataAlreadyUsedForExpiredAsset.title', {}, CHECKOUT_TRANSLOCO_SCOPE),
  forErrorTypes: ['METADATA_ALREADY_USED_FOR_EXPIRED_ASSET']
});

export const ERR_SPECS_FOR_CHECKOUT_ERROR_TYPES = (translocoService: TranslocoService, store: Store): TranslocoErrorSpecification[] => [
  ERR_METADATA_ALREADY_USED_FOR_EXPIRED_ASSET(translocoService, store ?? null)
];
